module.exports = __webpack_public_path__ + "static/img/bdc-trend-down.8839208c.svg";